import { render, staticRenderFns } from "./CreateWorkloadDialog.vue?vue&type=template&id=e5a8e9e2"
import script from "./CreateWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./CreateWorkloadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports